module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-thumbs-up-fill-32621a56.svg";